import React from "react";
import Objetivo from "./Objetivo";

function getLastMod(props) {
  var aux1 = props.goals.map(goal => {return (goal.lastModifiedAt)});
  var lastMod = "";
  for (var i = 0; i < aux1.length; i++) {
    if (aux1[i] && aux1[i] > lastMod) {
      lastMod = aux1[i];
    }
  }
  return lastMod;  
}

const Render = (props, context) => {
  let units = props.category.unidad || "kg";
  let unitsPre = "";
  if (props.category.unidad === "$") {
    unitsPre = "$";
    units = "";
  }

  var cl1 = "img pRel mask mha imgContainer " + props.category.clase;
  var likey = "_" + props.category.position;
  return (
    <li key={props.category.position} className="box borderBox">
      <div className="pRel borderBox clearfix">
        <div className={cl1}>
          <img
            src={props.category.icon}
            className="displayBlock"
            alt={props.category.name}
          />
        </div>
        <ul className="unstyled">
          <li key={likey} style={{height: 307}}>
            {props.goals.map(goal => (
              <Objetivo key={goal.id} goal={goal} units={units} unitsPre={unitsPre} />
            ))}
            <p className="actualizacion mts white horizontalCenter" style={{position: "absolute", bottom: 0 }}><span className="white horizontalCenter">Ult.Actualización:</span> {getLastMod(props)}</p>
          </li>
        </ul>
      </div>
    </li>
  );
};

Render.contextTypes = {};

export default Render;



// WEBPACK FOOTER //
// ./src/pages/DesafiosObjetivos/Desafio.js